module.exports = __webpack_public_path__ + "img/tabela.617cab60.svg";